'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'MaintenanceKindRestService',
    function ($modal, MaintenanceKindRestService) {

        return {
            select: select,
            create: create,
            edit: edit,
            api: MaintenanceKindRestService
        };

        function select(maintenanceKind) {
            return $modal.open({
                template: require('../view/maintenance-kind-modal-select.html'),
                controller: 'MaintenanceKindModalSelectController',
                size: 'md',
                backdrop: false,
                resolve: {
                    maintenanceKind: function () {
                        return maintenanceKind;
                    }
                }
            });
        }

        function create(def) {
            return $modal.open({
                template: require('../view/maintenance-kind-modal-create.html'),
                controller: 'MaintenanceKindModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    maintenanceKind: function () {
                        return {};
                    }
                }
            });
        }

        function edit(maintenanceKind) {
            return $modal.open({
                template: require('../view/maintenance-kind-modal-create.html'),
                controller: 'MaintenanceKindModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    maintenanceKind: function () {
                        return maintenanceKind;
                    }
                }
            });
        }

    }];